// text contents for Agreement.tsx
export const agreement = {
	newAgreement: {
		title: `Create New Agreement`,
		subtitle: `Please complete the form below.`,
		fleetId: `If you are unsure of your Telematic Solution Fleet Identifier,
              please contact getconnected@allisontransmission.com.`,
	},
	signAgreement: {
		title: `Please Review the Data Sharing Agreement and Sign Below`,
	},
	viewAgreement: {
		title: `Your Data Sharing Agreement`,
		error: `You do not have access to that agreement or the agreement you have requested does not exist.`,
	},
	successAgreement: {
		title: `You have successfully completed and signed the Data Sharing Agreement with Allison Transmission.
            You can review the signed Agreement below.`,
		changeAgreement: `If you need to make any changes/corrections to this agreement,
                      please contact getconnected@allisontransmission.com.`,
		welcomeEmail: `You will also receive a welcome email from Allison Transmission with a link to this portal.
                    You can always review details of the agreement by signing into the portal.`,
		viewInfo: `Now that you have completed the agreement, Allison Transmission can request to view
                the transmission related information from your Telematics Solution provider. This will
                enable transmission experts to perform data analysis and provide you with more
                information to maintain your fleet.`,
		neglectfulTsp: `If you do not see any additional transmission related information through your current
                    Telematics Solution provider within five (5) business days,
                    please contact getconnected@allisontransmission.com.`,
	},
};
